export var DEFAULT_MULTIVALUE_SEPARATOR = '; ';
export var columnTypes;
(function (columnTypes) {
    columnTypes["TEXT_TYPE"] = "TextColumn";
    columnTypes["BOOL_TYPE"] = "BooleanColumn";
    columnTypes["TIME_TYPE"] = "TimeColumn";
    columnTypes["DATE_TYPE"] = "DateColumn";
    columnTypes["PERCENTAGE_TYPE"] = "PercentageColumn";
    columnTypes["NUMBER_TYPE"] = "NumberColumn";
    columnTypes["ENUM_TYPE"] = "EnumColumn";
    columnTypes["HYPERLINK_TYPE"] = "HyperlinkColumn";
    columnTypes["DOWNLOAD_LINK_TYPE"] = "DownloadLinkColumn";
    columnTypes["ICON_TYPE"] = "IconColumn";
    columnTypes["TAG_TYPE"] = "TagColumn";
})(columnTypes || (columnTypes = {}));
export var AccurityFilterType;
(function (AccurityFilterType) {
    AccurityFilterType["SIMPLE_QUERY"] = "SIMPLE_QUERY";
    AccurityFilterType["REFERENCE"] = "REFERENCE";
    AccurityFilterType["EXCLUDE_REFERENCES"] = "EXCLUDE_REFERENCES";
    AccurityFilterType["DATE"] = "DATE";
    AccurityFilterType["DAY"] = "DAY";
    AccurityFilterType["CHILDREN_COUNT"] = "CHILDREN_COUNT";
    AccurityFilterType["IS_NULL"] = "IS_NULL";
    AccurityFilterType["ACTIVE_NOTIFICATION"] = "ACTIVE_NOTIFICATION";
    AccurityFilterType["CUSTOM_PROPERTY_TEXT"] = "CUSTOM_PROPERTY_TEXT";
    AccurityFilterType["CUSTOM_PROPERTY_ENUM"] = "CUSTOM_PROPERTY_ENUM";
    AccurityFilterType["CUSTOM_PROPERTY_NUMERIC"] = "CUSTOM_PROPERTY_NUMERIC";
})(AccurityFilterType || (AccurityFilterType = {}));
export var propertyTypes;
(function (propertyTypes) {
    propertyTypes["INDICATOR"] = "YES_NO";
    propertyTypes["HYPERLINK"] = "HYPERLINK";
    propertyTypes["DATE"] = "DATE";
})(propertyTypes || (propertyTypes = {}));
export var enumColumnTypes;
(function (enumColumnTypes) {
    enumColumnTypes["ICON_TYPE"] = "IconColumn";
    enumColumnTypes["TEXT_TYPE"] = "TextColumn";
})(enumColumnTypes || (enumColumnTypes = {}));
export var FILTER_VALUE_TYPE;
(function (FILTER_VALUE_TYPE) {
    FILTER_VALUE_TYPE["TIME"] = "time";
    FILTER_VALUE_TYPE["ANY"] = "any";
})(FILTER_VALUE_TYPE || (FILTER_VALUE_TYPE = {}));
export var TOOL_TIP_CLASS = 'accDataTable__tooltip';
export var Align;
(function (Align) {
    Align["LEFT"] = "LEFT";
    Align["RIGHT"] = "RIGHT";
    Align["CENTER"] = "CENTER";
})(Align || (Align = {}));
export var NumericFormat;
(function (NumericFormat) {
    NumericFormat["NUMERIC"] = "NUMERIC";
    NumericFormat["POSITIVE_NUMERIC"] = "POSITIVE_NUMERIC";
    NumericFormat["DECIMAL"] = "DECIMAL";
})(NumericFormat || (NumericFormat = {}));
//# sourceMappingURL=types.js.map